import { render } from "./ChangePlayer.vue?vue&type=template&id=2772ba5d&scoped=true"
import script from "./ChangePlayer.vue?vue&type=script&lang=js"
export * from "./ChangePlayer.vue?vue&type=script&lang=js"

import "./ChangePlayer.vue?vue&type=style&index=0&id=2772ba5d&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2772ba5d"]])

export default __exports__